import { useEffect } from "react";
import { ToggleButton, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveAirMilesTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const airMiles = useInput("2000");
  const isPurchase = useInput(false);
  const val = useInput("");
  const type = useInput("");
  const suffix = useInput("");

  const typeData = [
    { label: "$", value: "$", },
    { label: "Unit", value: "Unit" },
  ];

  const formatPurchase = (isP, v, t) => {
    if (isP) {
      if (t === "$") {
        return ` w/purchase/$${formatDollarValue(v)}`;
      } else {
        return ` w/purchase/${v}`;
      }
    } else {
      return "";
    }
  };

  const handleUpdateValue = (
    isUpto,
    airMiles,
    isPurchase,
    val,
    type,
    suffix
  ) => {
    onChange(
      `Earn${isUpto ? " Up To" : ""}${airMiles ? ` ${airMiles} air miles` : ""
      }${formatPurchase(isPurchase, val, type)}${suffix ? ` ${suffix}` : ""}`
    );
  };

  useEffect(() => {
    if (value.startsWith("Earn")) {
      let main = value.slice(4);
      if (main.startsWith("Up To")) {
        isUpTo.setValue(true);
        main = main.slice(5);
      } else {
        isUpTo.setValue(false);
      }
      if (main.length > 0) {
        const airmilesIndex = main.indexOf("air miles");
        if (airmilesIndex > 0) {
          airMiles.setValue(main.slice(0, airmilesIndex).trim());
          main = main.slice(airmilesIndex + 9);
        } else {
          airMiles.setValue("");
        }
        if (main.trim().startsWith("w/purchase/")) {
          main = main.trimStart();
          isPurchase.setValue(true);
          main = main.slice(11);
          const suffixIndex = main.indexOf(" ");
          if (suffixIndex >= 0) {
            suffix.setValue(main.slice(suffixIndex + 1));
            let purchaseVal = main.slice(0, suffixIndex).trim();
            if (purchaseVal.startsWith("$")) {
              type.setValue("$");
              purchaseVal = purchaseVal.slice(1).trim();
            } else {
              type.setValue("Unit");
            }
            val.setValue(purchaseVal.trim());
          } else {
            if (main.startsWith("$")) {
              type.setValue("$");
              main = main.slice(1).trim();
            } else {
              type.setValue("Unit");
            }
            val.setValue(main.trim());
            suffix.setValue("");
          }
        } else {
          isPurchase.setValue(false);
          val.setValue("");
          type.setValue("");
          suffix.setValue(main.slice(1));
        }
      }
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3 mr-2" >Earn</div>

        <ToggleButton className="mt-3 mr-2" label="Up To" value={isUpTo.value}
          style={{ width: '30%' }}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, airMiles.value, isPurchase.value, val.value, type.value, suffix.value);
          }}
        />

        <LabelledInput label="Air Miles" placeholder="Air Miles"
          allowclear="true" value={airMiles.value}
          onChange={(e) => {
            airMiles.setValue(e);
            handleUpdateValue(isUpTo.value, e, isPurchase.value, val.value, type.value, suffix.value);
          }}
        />
      </div>

      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton className="mt-3 mr-2" label="w/purchase" value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            if (!e) {
              val.setValue("");
              type.setValue("");
            }
            handleUpdateValue(
              isUpTo.value,
              airMiles.value,
              e,
              e ? val.value : "",
              e ? type.value : "Unit",
              suffix.value
            );
          }}
        />

        {type.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '96%' }}
            value={val.value} disabled={!isPurchase.value}
            onChange={(e) => {
              val.setValue(e);
              handleUpdateValue(isUpTo.value, airMiles.value, isPurchase.value, e, type.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={val.value} disabled={!isPurchase.value}
            onChange={(e) => {
              val.setValue(e);
              handleUpdateValue(isUpTo.value, airMiles.value, isPurchase.value, e, type.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '96%' }}
          options={typeData} value={type.value} disabled={!isPurchase.value}
          onChange={(e) => {
            type.setValue(e);
            handleUpdateValue(isUpTo.value, airMiles.value, isPurchase.value, val.value, e, suffix.value);
          }} />

        <LabelledInput label="Suffix" placeholder="Suffix" style={{ width: '96%' }}
          allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, airMiles.value, isPurchase.value, val.value, type.value, e);
          }}
        />
      </div>
    </>
  );
};